"use strict";

var LoggerInstance = require("js-logger").get("AbstractPledgeManagementHelper");

var AccountStore = require("./AccountStore");
var PledgeStatementHelper = require("./PledgeStatementHelper");

var Spinner = require("../client/Spinner");

var WizardConstants = require("../constants/WizardConstants");

var ActionsHelper = require("../actions/ActionsHelper");
var MyRecurringRefresh = require("./MyRecurringRefresh");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var InputHelper = require("../shared/InputHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");

var AbstractPledgeManagementHelper = class {
	constructor(options) {
		options = options || {};

		if (this.constructor === AbstractPledgeManagementHelper) {
			throw new TypeError("Cannot construct AbstractPledgeManagementHelper instances directly!");
		}

		// private properties
		this._cancelPledgeEditLinkMessageMapper = options.cancelPledgeEditLinkMessageMapper;
		this._cancelWholePledgeLinkMessageMapper = options.cancelWholePledgeLinkMessageMapper;
		this._componentSelector = options.componentSelector;
		this._displayMessagesWizard = options.displayMessagesWizard;
		this._donateToAllCheckboxComponentName = options.donateToAllCheckboxComponentName;
		this._donateToAllCheckboxSelector = options.donateToAllCheckboxSelector;
		this._donateToAllCheckboxInputSelector = options.donateToAllCheckboxInputSelector || options.donateToAllCheckboxSelector;
		this._donateToSingleCheckboxComponentName = options.donateToSingleCheckboxComponentName;
		this._donateToSingleCheckboxSelector = options.donateToSingleCheckboxSelector;
		this._donateToSingleCheckboxInputSelector = options.donateToSingleCheckboxInputSelector || options.donateToSingleCheckboxSelector;
		this._editMyPledgeLinkMessageMapper = options.editMyPledgeLinkMessageMapper;
		this._makeDonationSelector = options.makeDonationSelector;
		this._myRecurringPopulatedSingleRecurringSelector = options.myRecurringPopulatedSingleRecurringSelector;
		this._myRecurringSelector = options.myRecurringSelector;
		this._singlePledgeEditComponentName = options.singlePledgeEditComponentName;
		this._singlePledgeSelector = options.singlePledgeSelector;
		this._singlePledgeEditSelector = options.singlePledgeEditSelector;
		this._singlePledgeEditAmountSelector = options.singlePledgeEditAmountSelector;

		// private methods
		this._donateToAllClicked = (event, isDesignMode) => {
			if (isDesignMode && (!event.ctrlKey && !event.metaKey)) {
				return;
			}

			var $checkbox = $(event.target);
			var reverseChecked = false;
			if (!$checkbox.is(":input")) {
				$checkbox = $checkbox.closest(this.donateToAllCheckboxSelector).find(this.donateToAllCheckboxInputSelector);
				reverseChecked = true;
			}
			var isChecked = $checkbox.prop("checked");
			if (reverseChecked) {
				isChecked = !isChecked;
			}
			var $component = $checkbox.closest(this.componentSelector);

			$component.find(this.donateToAllCheckboxInputSelector).prop("checked", isChecked);
			$component.find(`${this.donateToSingleCheckboxInputSelector}:not(:disabled)`).prop("checked", isChecked);
		};

		this._donateToSingleClicked = (event, isDesignMode) => {
			if (isDesignMode && (!event.ctrlKey && !event.metaKey)) {
				return;
			}

			var $checkbox = $(event.target);
			var reverseChecked = false;
			if (!$checkbox.is(":input")) {
				$checkbox = $checkbox.closest(this.donateToSingleCheckboxSelector).find(this.donateToSingleCheckboxInputSelector);
				reverseChecked = true;
			}
			var isChecked = $checkbox.prop("checked");
			if (reverseChecked) {
				isChecked = !isChecked;
			}

			$checkbox.prop("checked", isChecked);
		};

		this._getEventOrReturn = (event, isDesignModeMessage, isDesignMode) => {
			return ActionsHelper.getEventOrReturn(event, isDesignMode != null ? isDesignMode : AccountStore.get("isDesignMode"), isDesignModeMessage, /*preventDefaultInDesignMode*/false); //coersion, because we want to check for null or undefined
		};

		this._refreshAssociatedRecurringHtml = pledgeId => {
			//We first need to get the recurring container, then we can iterate through each recurring and update it if needed.
			var $recurringContainer = $(this.myRecurringSelector);
			var promises = [];

			var $recurringDonations = $recurringContainer.find(`[data-pledge-id="${pledgeId}"]`);

			$recurringDonations.each((index, element) => {
				var deferred = new $.Deferred();
				var recurringDonationId = $(element).attr("data-donation-id");

				MyRecurringRefresh.getMyRecurringHtml(
					{
						target: $(element).closest(this.myRecurringPopulatedSingleRecurringSelector)
					},
					/*isEditing*/ false,
					{
						donationId: recurringDonationId,
						usingDonations: true,
						usingHeader: true
					}
				).done(() => {
					deferred.resolve();
				});

				promises.push(deferred);
			});

			return $.when.apply(undefined, promises).promise();
		};

		this._resolveError = (jqXHR, textStatus, deferred) => {
			if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
				//There was not a partial error, so do what we normally would do.
				ApiHelper.displayErrorMessage(jqXHR);
			}

			if (deferred) {
				deferred.reject(jqXHR, textStatus);
			}
		};
	}

	// public getters for private properties
	get cancelPledgeEditLinkMessageMapper() {
		return this._cancelPledgeEditLinkMessageMapper;
	}

	get cancelWholePledgeLinkMessageMapper() {
		return this._cancelWholePledgeLinkMessageMapper;
	}

	get componentSelector() {
		return this._componentSelector;
	}

	get displayMessagesWizard() {
		return this._displayMessagesWizard;
	}

	get donateToAllCheckboxComponentName() {
		return this._donateToAllCheckboxComponentName;
	}

	get donateToAllCheckboxSelector() {
		return this._donateToAllCheckboxSelector;
	}

	get donateToAllCheckboxInputSelector() {
		return this._donateToAllCheckboxInputSelector;
	}

	get donateToSingleCheckboxComponentName() {
		return this._donateToSingleCheckboxComponentName;
	}

	get donateToSingleCheckboxSelector() {
		return this._donateToSingleCheckboxSelector;
	}

	get donateToSingleCheckboxInputSelector() {
		return this._donateToSingleCheckboxInputSelector;
	}

	get editMyPledgeLinkMessageMapper() {
		return this._editMyPledgeLinkMessageMapper;
	}

	get makeDonationSelector() {
		return this._makeDonationSelector;
	}

	get myRecurringPopulatedSingleRecurringSelector() {
		return this._myRecurringPopulatedSingleRecurringSelector;
	}

	get myRecurringSelector() {
		return this._myRecurringSelector;
	}

	get singlePledgeEditComponentName() {
		return this._singlePledgeEditComponentName;
	}

	get singlePledgeSelector() {
		return this._singlePledgeSelector;
	}

	get singlePledgeEditSelector() {
		return this._singlePledgeEditSelector;
	}

	get singlePledgeEditAmountSelector() {
		return this._singlePledgeEditAmountSelector;
	}

	//public methods
	getComponentHtml(event, newPledgeId, retrievePledgeApiFunction) {
		if(typeof retrievePledgeApiFunction != "function") {
			throw new Error(`${this.constructor}.getComponentHtml() requires retrievePledgeApiFunction to be a function.`);
		}

		var deferred = new $.Deferred();
		var $currentPledge = $(event.target).closest(this.singlePledgeSelector);
		var pledgeId = newPledgeId || $currentPledge.attr("data-pledge-id");
		var componentId = $currentPledge.closest(this.componentSelector).attr("id");

		retrievePledgeApiFunction($currentPledge, pledgeId, componentId, deferred);

		return deferred;
	}

	cancelPledgeEdit(event, getPledgeViewData) {
		if (typeof getPledgeViewData != "function") {
			throw new Error(`${this.constructor}.cancelPledgeEdit() requires getPledgeViewData to be a function.`);
		}

		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper(this.cancelPledgeEditLinkMessageMapper));
		if (!event) {
			return false;
		}

		var $currentPledge = $(event.target).closest(this.singlePledgeSelector);
		Spinner.showSpinner($currentPledge);

		getPledgeViewData($currentPledge);

		return false;
	}

	cancelWholePledge(event, cancelPledgeApiFunction) {
		if (typeof cancelPledgeApiFunction != "function") {
			throw new Error(`${this.constructor}.cancelWholePledge() requires cancelPledgeApiFunction to be a function.`);
		}

		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper(this.cancelWholePledgeLinkMessageMapper));
		if (!event) {
			return false;
		}

		BootstrapPrompt.confirm({
			btnCancelLabel: window.BUTTON_LABELS.NO,
			btnOKLabel: window.BUTTON_LABELS.YES,
			message: AccountStore.get(this.displayMessagesWizard).cancelPledge,
			title: ""
		}, (result) => {
			if (result) {
				Spinner.showSpinner();

				var $currentPledge = $(event.target).closest(this.singlePledgeSelector);
				var pledgeId = $currentPledge.attr("data-pledge-id");

				cancelPledgeApiFunction($currentPledge, pledgeId);
			}
		});

		return false;
	}

	editPledge(event, getPledgeEditData) {
		if (typeof getPledgeEditData != "function") {
			throw new Error(`${this.constructor}.editPledge() requires getPledgeEditData to be a function.`);
		}

		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper(this.editMyPledgeLinkMessageMapper));
		if (!event || this.alreadyEditingHeader) {
			return false;
		}

		var $currentPledge = $(event.target).closest(this.singlePledgeSelector);
		Spinner.showSpinner($currentPledge);
		getPledgeEditData($currentPledge);

		return false;
	}

	makeDonation(event, isDesignMode, makeDonationApiFunction) {
		if (typeof makeDonationApiFunction != "function") {
			throw new Error(`${this.constructor}.makeDonation() requires makeDonationApiFunction to be a function.`);
		}

		event = this._getEventOrReturn(event, "Make Donation called successfully.", isDesignMode);
		if (!event || this.alreadyEditingHeader) {
			return false;
		}

		var isInPledgeStatementSession = AccountStore.get("isInPledgeStatementSession");
		var pledgeStatementEntryWizard = AccountStore.get(WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY);

		PledgeStatementHelper.confirmAbandonPledgeStatementSession(isInPledgeStatementSession, pledgeStatementEntryWizard).done(() => {
			Spinner.showSpinner();

			var $component = $(event.target).closest(this.componentSelector);
			var pledgeIds = $component.find(`${this.donateToSingleCheckboxInputSelector}:checked`).closest(this.singlePledgeSelector).map((index, element) => {
				return $(element).attr("data-pledge-id");
			}).get();

			if (!pledgeIds || !pledgeIds.length) {
				var errorMessage = AccountStore.get(this.displayMessagesWizard).makeDonationSelectionRequired;
				BootstrapPrompt.alert(errorMessage);
				Spinner.removeSpinner();
				return false;
			}

			makeDonationApiFunction(pledgeIds);
		});

		return false;
	}

	initializeComponent($component, isDesignMode) {
		//Need to disable the checkbox if we cannot donate to the pledge.  This happens when the pledge does not have a defaultProjectCode.
		$component = $($component || "body");
		$component.find(this.donateToSingleCheckboxSelector).each((index, element) => {
			var $checkbox = $(element);

			if ($checkbox.closest(this.singlePledgeSelector).attr("data-can-donate") === "false") {
				$checkbox.prop("disabled", true);
			}
		});

		//If we check a Donate to All checkbox, check all Donate to All and all Donate to Single checkboxes (that are not disabled)
		$component.find(this.donateToAllCheckboxSelector).off("click.myPledges", this._donateToAllClicked).on("click.myPledges",event => {
			this._donateToAllClicked(event, isDesignMode);
		});
		//If we uncheck a Donate To Single, uncheck all Donate to All checkboxes.
		$component.find(this.donateToSingleCheckboxSelector).off("click.myPledges", this._donateToSingleClicked).on("click.myPledges",event => {
			this._donateToSingleClicked(event, isDesignMode);
		});

		//Correcting the for attribute on checkbox labels
		InputHelper.prepareCheckboxAndLabel($component, this.donateToAllCheckboxComponentName, this.singlePledgeSelector);
		InputHelper.prepareCheckboxAndLabel($component, this.donateToSingleCheckboxComponentName, this.singlePledgeSelector);

		this.initializePledgeButtons($component, isDesignMode);
	}

	initializePledgeButtons($component, isDesignMode) {
		//Setting onclick on the MakeDonation button
		$component.find(this.makeDonationSelector).addBack(this.makeDonationSelector).off("click.myPledges", this.makeDonation).on("click.myPledges", event => {
			this.makeDonation(event, isDesignMode);
		});
	}

	initializeEdit($component) {
		InputHelper.initializeAmountInput($component || $(this.componentSelector), this.singlePledgeEditAmountSelector);
	}

	save(event, savePledgeApiFunction) {
		if (typeof savePledgeApiFunction != "function") {
			throw new Error(`${this.constructor}.save() requires savePledgeApiFunction to be a function.`);
		}

		event = this._getEventOrReturn(event, "Save Pledge called successfully.");
		if (!event) {
			return false;
		}

		Spinner.showSpinner();

		var $currentPledge = $(event.target).closest(this.singlePledgeSelector);
		var pledgeId = $currentPledge.attr("data-pledge-id");
		var componentId = $currentPledge.closest(this.componentSelector).attr("id");

		var $editPledgeForm = $(event.target).closest(this.singlePledgeEditSelector).find(`form#${this.editMyPledgeLinkMessageMapper}-${pledgeId}`);
		var editPledgeData = ActionsHelper.serializeForm($editPledgeForm);

		var errorMessage;
		//Check if the donation amount is greater than zero
		if (editPledgeData.amount) {
			editPledgeData.amount = ActionsHelper.convertFormattedAmountToNumber(editPledgeData.amount);
			if (!(Number(editPledgeData.amount) > 0)) {
				errorMessage = AccountStore.get(this.displayMessagesWizard).pledgeAmountGreaterThanZero;
			}
		}

		if (errorMessage) {
			BootstrapPrompt.alert(errorMessage);
			Spinner.removeSpinner();
			return false;
		}

		savePledgeApiFunction($currentPledge, pledgeId, componentId, editPledgeData);

		return false;
	}
};

module.exports = AbstractPledgeManagementHelper;
